import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROPOSAL_CONFIG_FEATURE_KEY,
  ProposalConfigState,
  proposalConfigAdapter,
} from './proposal-config.reducer';

const selectProposalConfigState = createFeatureSelector<ProposalConfigState>(
  PROPOSAL_CONFIG_FEATURE_KEY
);

const { selectAll: selectAllContsructor, selectEntities } =
  proposalConfigAdapter.getSelectors();

export const selectAll = createSelector(
  selectProposalConfigState,
  (state: ProposalConfigState) => selectAllContsructor(state)
);

export const selectProposalConfigs = createSelector(
  selectProposalConfigState,
  (state: ProposalConfigState) => selectEntities(state)
);

export const ProposalConfigSelectors = {
  selectAll,
  selectProposalConfigs,
};
